<template>
  <ODialog ref="dialog" :maxWidth="400" hide-if-loading>
    <v-card v-if="row != null">
      <ODialogBar
        title="Editar Regra de Notificação"
        @close="$refs.dialog.$dismiss()"
      />

      <v-card-text class="pa-6">
        <div class="v-row">
          <div class="cap-cont mb-4" v-if="account != null">
            <label>Conta:</label>
            <p>
              <router-link :to="`/tools/gateman/accounts/${account.id}`">
                {{ account.fullName }} &mdash; {{ account.email }}
              </router-link>
            </p>
          </div>
          <div>
            <v-text-field
              v-model="row.name"
              label="Descrição da regra"
              required
            />
          </div>
          <div>
            <OArrayInput
              v-model="row.criteria.tags"
              label="Com TODAS as tags"
              hint="(digite tags separadas por espaços)"
            />
          </div>

          <div>
            <OArrayInput
              v-model="row.criteria.withoutTags"
              label="Com NENHUMA das tags"
              hint="(digite tags separadas por espaços)"
            />
          </div>
          <div>
            <OArrayInput
              v-model="row.criteria.sources"
              label="De UMA destas origens"
              hint="(digite origens separadas por espaços)"
            />
          </div>
          <div>
            <OArrayInput
              v-model="row.criteria.withoutSources"
              label="De NENHUMA destas origens"
              hint="(digite origens separadas por espaços)"
            />
          </div>
        </div>
      </v-card-text>

      <ODialogButtons
        class="pa-6"
        txtApply="Salvar"
        :show-delete="row.id != null"
        txtDelete="Remover"
        @delete="$refs.dialog.$apply('DELETE')"
        @cancel="$refs.dialog.$dismiss()"
        @apply="$refs.dialog.$apply(row)"
      />
    </v-card>
  </ODialog>
</template>

<script>
import { Account, Subscription } from '@/models'

export default {
  components: {
    ODialog: require('oderon-vue/cpts/ODialog').default,
    ODialogBar: require('oderon-vue/cpts/ODialogBar').default,
    ODialogButtons: require('oderon-vue/cpts/ODialogButtons').default,
    OArrayInput: require('oderon-vue/cpts/OArrayInput').default
  },
  data() {
    return {
      isLoading: true,
      row: null,
      account: null
    }
  },
  methods: {
    open(id) {
      this.id = id
      this.account = null
      this.row = null
      this.$refs.dialog.$loading(() => this.fetchData())
      return this.$refs.dialog.$open()
    },
    async fetchData() {
      if (this.id == null) {
        this.row = {
          criteria: {
            tags: [],
            withoutTags: [],
            sources: [],
            withoutSources: []
          },
          viaEmail: true
        }
      } else {
        let row = await Subscription.findById(this.id)
        let account = await Account.findById(row.accountId || row.account)
        this.row = row
        this.account = account
      }
    }
  }
}
</script>

<style></style>
